import { Button, ConfirmDialog, DotsHorizontalIcon, DropdownMenu2, Text, useVisibilityToggle } from "@workflows/ui";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDeleteMatter } from "../hooks/useDeleteMatter";
export const MattersListMenu = ({
  matter
}: any) => {
  const {
    deleteMatter,
    isPending
  } = useDeleteMatter();
  const {
    t
  } = useTranslation("ai.workflows.matters", {
    keyPrefix: "MattersListMenu"
  });
  const [confirmDialogIsVisible, show, hide] = useVisibilityToggle(false);
  const onConfirm = (result: boolean) => {
    if (result) {
      deleteMatter({
        input: {
          matterId: matter.id
        }
      });
    } else {
      hide();
    }
  };
  const number = matter.number > 0 ? `#${matter.number}` : "DRAFT";
  return <>
      <DropdownMenu2 target={<Button minimal>
            <DotsHorizontalIcon />
          </Button>}>
        <DropdownMenu2.Item onClick={show}>{t("delete")}</DropdownMenu2.Item>
      </DropdownMenu2>
      <ConfirmDialog isOpen={confirmDialogIsVisible} isPending={isPending} showIcon={false} onConfirm={result => onConfirm(result)} title="Löschen bestätigen" intent="critical">
        {" "}
        <Trans i18nKey="deleteConfirmation">
          Möchten Sie {{
          matterTitle: matter.titleText
        }}{" "}
          <Text color="muted" as="span">
            ({({
            number
          } as any)})
          </Text>{" "}
          unwiderruflich löschen?
        </Trans>
      </ConfirmDialog>
    </>;
};